export enum TransactionCardNetworkCode {
  Visa = 'VISA',
  Mastercard = 'MASTERCARD',
  Cb = 'CB'
}
